// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"c52ef06a","122":"fdbadd54","434":"995c7a53","845":"e4de1a2c","954":"2123e02d"}[chunkId] + ".chunk.js";
};